module.exports = __webpack_public_path__ + "img/9.1d5920fb.png";